import React, { useContext } from 'react';

// allows to provide components that are out of Workspace and ui folder to have an access to the value of phoneFeature flag.
// which activates a tooltip with support phone number

export const PhoneFeatureContext = React.createContext<boolean>(false);

export const usePhoneFeatureContext = () => useContext(PhoneFeatureContext);